import isNodeDetected from 'detect-node';
export var isBackend = isNodeDetected || typeof window === 'undefined';
